import { defaultReducerMapping } from 'app/fs/lib/redux'
import deepFreeze from 'deep-freeze'

var { APP_SIGN_OUT } = require('../actions/app')

var {
  MEMBER_SEARCH_CHANGE_QUERY,
  MEMBER_SEARCH_REFRESH,
  MEMBER_SEARCH_FETCH_PAGE,
  MEMBER_SEARCH_FETCH_PAGE_COMPLETE,
  MEMBER_SEARCH_FETCH_PAGE_FAILED
} = require('../actions/memberSearch')

var initialState = deepFreeze({
  query: '',
  loaded: false,
  page: 1,
  refreshing: false,
  loadingPage: false,
  noMoreData: false,
  userIds: []
})

//Just return the new/change parts of the state
var map = {}

map[MEMBER_SEARCH_REFRESH] = (state, action) => {
  return {
    refreshing: true,
    page: 1
  }
}

map[MEMBER_SEARCH_CHANGE_QUERY] = (state, action) => {
  if (action.query === '') {
    return initialState
  } else {
    return {
      query: action.query,
      noMoreData: false,
      page: 1
    }
  }
}

map[MEMBER_SEARCH_FETCH_PAGE] = (state, action) => {
  return {
    loaded: true,
    loadingPage: true
  }
}

map[MEMBER_SEARCH_FETCH_PAGE_COMPLETE] = (state, action) => {
  var matches = action.matches || []
  var newResultIds = matches.map(u => u.id)

  return {
    loaded: true,
    loadingPage: false,
    refreshing: false,
    page: state.page + 1,
    noMoreData: matches.length === 0,
    userIds: state.refreshing || action.page === 1 ? newResultIds : state.userIds.concat(newResultIds)
  }
}

map[MEMBER_SEARCH_FETCH_PAGE_FAILED] = (state, action) => {
  return {
    loaded: true,
    loadingPage: false,
    refreshing: false,
    noMoreData: true
  }
}

map[APP_SIGN_OUT] = (state, action) => {
  return initialState
}

export default defaultReducerMapping(initialState, map)
